import config from '../config';
import { storagePersistent } from './storage';
import { slugify } from './text';

const PREFIX = `${slugify(config.application.name || '').toLowerCase()}.${process.env.NODE_ENV}.`;

export function persistData(key, data, escapePrefix = false) {
    if(storagePersistent) {
        storagePersistent.setItem(escapePrefix ? key : PREFIX + key, data ? JSON.stringify(data) : '');
    }
}

export function getPersistedData(key, defaultData = {}, escapePrefix = false) {
    if(storagePersistent) {
        try {
            const data = storagePersistent.getItem(escapePrefix ? key : PREFIX + key) && JSON.parse(storagePersistent.getItem(escapePrefix ? key : PREFIX + key));
            return data || defaultData;
        } catch (e) {
            return defaultData;
        }
    }
    return defaultData;
}
